import { render, staticRenderFns } from "./order-history.vue?vue&type=template&id=459b51c6&scoped=true&"
import script from "./order-history.vue?vue&type=script&lang=js&"
export * from "./order-history.vue?vue&type=script&lang=js&"
import style0 from "./order-history.vue?vue&type=style&index=0&id=459b51c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b51c6",
  null
  
)

export default component.exports